<div class="user-management-container">
    <div class="header">
        <h1>User Management</h1>
        <button mat-raised-button style="background-color: #757575; color:white" (click)="openCreateUserDialog()">
            <mat-icon>add</mat-icon>
            Create User
        </button>
    </div>

    <mat-card>
        <mat-card-content>
            <table mat-table [dataSource]="dataSource" class="user-table">
                <!-- Email Column -->
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef>Email</th>
                    <td mat-cell *matCellDef="let user">{{user.email}}</td>
                </ng-container>

                <!-- Roles Column -->
                <ng-container matColumnDef="roles">
                    <th mat-header-cell *matHeaderCellDef>Roles</th>
                    <td mat-cell *matCellDef="let user">
                        <mat-chip-list>
                            <mat-chip *ngFor="let role of user.roles" [color]="role === 'admin' ? 'primary' : 'accent'">
                                {{role}}
                            </mat-chip>
                        </mat-chip-list>
                    </td>
                </ng-container>
                <!-- First Name Column -->
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef>First Name</th>
                    <td mat-cell *matCellDef="let user">{{user.firstName || '-'}}</td>
                </ng-container>

                <!-- Last Name Column -->
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef>Last Name</th>
                    <td mat-cell *matCellDef="let user">{{user.lastName || '-'}}</td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let user">
                        <mat-slide-toggle
                            [checked]="user.isActive"
                            (change)="toggleUserStatus(user)"
                            [disabled]="user.firebaseUserId === (currentUser$ | async)?.uid || !(hasRole$('admin') | async)">
                            {{user.isActive ? 'Active' : 'Inactive'}}
                        </mat-slide-toggle>
                    </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let user">
                        <button mat-icon-button (click)="openEditUserDialog(user)" [disabled]="!(hasRole$('admin') | async)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button color="warn" (click)="deleteUser(user)" [disabled]="user.firebaseUserId === (currentUser$ | async)?.uid || !(hasRole$('admin') | async)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </mat-card-content>
    </mat-card>
</div> 